import { logError } from './helpers';
export const safeDocument = {
    get title() {
        try {
            return typeof document !== 'undefined' ? document.title || '' : '';
        }
        catch (e) {
            logError(true, 'Error getting document title', e);
            return '';
        }
    },
    get referrer() {
        try {
            return typeof document !== 'undefined'
                ? document.referrer || ''
                : '';
        }
        catch (e) {
            logError(true, 'Error getting document referrer', e);
            return '';
        }
    },
    get hidden() {
        try {
            return typeof document !== 'undefined'
                ? document.hidden || false
                : false;
        }
        catch (e) {
            logError(true, 'Error getting document hidden', e);
            return false;
        }
    },
    querySelectorAll: (selector) => {
        try {
            return typeof document !== 'undefined'
                ? document.querySelectorAll(selector)
                : [];
        }
        catch (e) {
            logError(true, 'Error getting document querySelectorAll', e);
            return [];
        }
    },
    addEventListener: (type, listener, options) => {
        try {
            if (typeof document !== 'undefined' && document.addEventListener) {
                document.addEventListener(type, listener, options);
                return true;
            }
            return false;
        }
        catch (e) {
            logError(true, 'Error adding document event listener', e);
            return false;
        }
    },
    removeEventListener: (type, listener, options) => {
        try {
            if (typeof document !== 'undefined' &&
                document.removeEventListener) {
                document.removeEventListener(type, listener, options);
                return true;
            }
            return false;
        }
        catch (e) {
            logError(true, 'Error removing document event listener', e);
            return false;
        }
    },
};
export const safeWindow = {
    get location() {
        try {
            if (typeof window !== 'undefined' && window.location) {
                return {
                    href: window.location.href || '',
                    pathname: window.location.pathname || '',
                    search: window.location.search || '',
                };
            }
        }
        catch (e) {
            logError(true, 'Error getting window location', e);
        }
        // Fallback
        return { href: '', pathname: '', search: '' };
    },
    get screen() {
        try {
            if (typeof window !== 'undefined' && window.screen) {
                return {
                    width: window.screen.width || 0,
                    height: window.screen.height || 0,
                };
            }
        }
        catch (e) {
            logError(true, 'Error getting window screen', e);
        }
        // Fallback
        return { width: 0, height: 0 };
    },
    get devicePixelRatio() {
        try {
            return typeof window !== 'undefined'
                ? window.devicePixelRatio || 1
                : 1;
        }
        catch (e) {
            logError(true, 'Error getting window devicePixelRatio', e);
            // Fallback
            return 1;
        }
    },
    get doNotTrack() {
        try {
            return typeof window !== 'undefined'
                ? window.doNotTrack || null
                : null;
        }
        catch (e) {
            logError(true, 'Error getting window doNotTrack', e);
            return null;
        }
    },
    addEventListener: (type, listener, options) => {
        try {
            if (typeof window !== 'undefined' && window.addEventListener) {
                window.addEventListener(type, listener, options);
                return true;
            }
            return false;
        }
        catch (e) {
            logError(true, 'Error adding window event listener', e);
            return false;
        }
    },
    removeEventListener: (type, listener, options) => {
        try {
            if (typeof window !== 'undefined' && window.removeEventListener) {
                window.removeEventListener(type, listener, options);
                return true;
            }
            return false;
        }
        catch (e) {
            logError(true, 'Error removing window event listener', e);
            return false;
        }
    },
};
export const safeNavigator = {
    get doNotTrack() {
        try {
            return typeof navigator !== 'undefined'
                ? navigator.doNotTrack || null
                : null;
        }
        catch (e) {
            logError(true, 'Error getting navigator doNotTrack', e);
            return null;
        }
    },
    get globalPrivacyControl() {
        try {
            return typeof navigator !== 'undefined'
                ? navigator.globalPrivacyControl
                : undefined;
        }
        catch (e) {
            logError(true, 'Error getting navigator globalPrivacyControl', e);
            return undefined;
        }
    },
    get userAgent() {
        try {
            return typeof navigator !== 'undefined'
                ? navigator.userAgent || ''
                : '';
        }
        catch (e) {
            logError(true, 'Error getting navigator userAgent', e);
            return '';
        }
    },
    get language() {
        try {
            return typeof navigator !== 'undefined' && navigator.language
                ? navigator.language
                : 'en';
        }
        catch (e) {
            logError(true, 'Error getting navigator language', e);
            return 'en';
        }
    },
    get sendBeacon() {
        try {
            return typeof navigator !== 'undefined'
                ? navigator.sendBeacon?.bind(navigator)
                : undefined;
        }
        catch (e) {
            logError(true, 'Error getting navigator sendBeacon', e);
            return undefined;
        }
    },
};
export const safePerformance = {
    now: () => {
        try {
            return typeof performance !== 'undefined' && performance.now
                ? performance.now()
                : Date.now();
        }
        catch (e) {
            logError(true, 'Error getting performance now', e);
            return Date.now();
        }
    },
};
